GameView  = require "views/base/game"
{ dpi }   = require("lib/device")

class MultipleChoiceGameView extends GameView
  template: require("./template")

  events:
    "iostap .selectable": "selectAnswer"
    "iostap .btn-done": "endGame"
    "iostap .multi-content-wrapper-image": "showZoom"

  serialize: ->
    data = super

    answers = data.metadata.questions?[0]?.answers or []
    answers = answers.filter (m) -> m.content?

    longest = _.max(answers, (answer) -> answer.content?.length or 0)
    isLong  = longest.content?.length > Math.min(data.width / 16, 30)

    answers =
      for answer in answers
        _.extend {}, answer,
          isLong: isLong
          bottom: /the above/i.test(answer.content)

    answers       = _.shuffle(answers) if data.randomize
    bottomAnswers = _.where(answers, bottom: true)
    otherAnswers  = _.without(answers, bottomAnswers...)
    data.answers  = otherAnswers.concat(bottomAnswers)

    data

  render: ->
    super

    @setEl @findOne(".inner-content"), "innerContent"
    @setEl @findAll(".selectable"), "answers"
    @setEl [], "selected"

    @onTimerChange(@game.timer)

    window.setTimeout (=>
      @getEl("innerContent").style.overflowY = "auto"
    ), 1500

  refresh: ->
    super

    @showFocusImage()

  show: ->
    super

    @setState("prompt")

    for el in @getEl("answers") or []
      el.classList.remove("active")

    @enterGame()
    @showFocusImage()

  showFocusImage: ->
    canFocusImage = false

    if @options.data.titleType is "image" or @options.data.additionalContentType is "image"
      window.setTimeout =>
        for img in @findAll(".multi-content-image")
          imgRect = img.getBoundingClientRect()
          canFocusImage = imgRect.height < (img.naturalHeight or img.height) or imgRect.width < (img.naturalWidth or img.width)
        
        @setState canFocusImage, "image-focus"
      , 100

  showZoom: (e) ->
    img  = e.currentTarget.querySelector(".multi-content-image")
    rect = img.getBoundingClientRect()

    if rect.height < (img.naturalHeight or img.height) or
       rect.width  < (img.naturalWidth or img.width)
      @photoswipe = new PhotoSwipe(
        document.querySelector("#photoswipe")
        PhotoSwipeUI_Default
        [
          msrc: img.src
          src:  img.src
          title: written.wrapInTag(@options.data.subtitle or "", "h2")
          w: (img.naturalWidth  or img.width)  / Math.min(dpi, 1.66)
          h: (img.naturalHeight or img.height) / Math.min(dpi, 1.66)
        ]
        {
          focus: false
          history: false
          barsSize: {top: 0, bottom: 0 }
          getThumbBoundsFn: -> { x: rect.left, y: rect.top, w: rect.width }
        }
      )

      @photoswipe.listen("close", => @setState(false, "focus"))
      @photoswipe.init()

  endGame: ->
    super

    @submit()

  selectAnswer: (e) ->
    return if @currentState.state is "complete"

    selected = @getEl("selected")

    el = e.currentTarget

    if @options.data.selectable is 1 and
       el.classList.contains("active")
      return

    el.classList.toggle("active")

    if el.classList.contains("active")
      if selected.length >= @options.data.selectable
        selected.shift()?.classList.remove("active")

      selected.push(el)
    else
      selected = _.without(selected, el)

    @setEl(selected, "selected")
    @setState("touched")

  noDifference: (arr1, arr2) ->
    _.chain(arr1)
      .difference(arr2)
      .isEmpty()
      .value()

  answerDetails: ->
    questions = @options.strippedMetadata.questions or []
    return [] unless questions.length > 0
    
    question = questions[0]
    selectedAnswerIds = @getEl("selected").map  (e) -> @$(e).data("answer-id")
    answers  = question.answers.filter ({ id }) -> id in selectedAnswerIds
    details  = answers.map (a) -> question: question.question, answer: a
    return details

  isCorrect: ->
    selected = @getEl("selected")
    correct  = _.chain(@getEl("answers"))
      .filter((el) -> el.classList.contains("correct"))
      .value()

    @noDifference(correct, selected) and @noDifference(selected, correct)

module.exports = MultipleChoiceGameView
